import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : false;
  });

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  const theme = {
    isDark,
    toggleTheme,
    colors: isDark ? darkColors : lightColors
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

const lightColors = {
  page: '#f0f4f8',
  header: '#1a1a2e',
  card: '#ffffff',
  text: '#1a1a2e',
  textSecondary: '#334455',
  textLight: '#556677',
  textMuted: '#8899aa',
  border: '#e8edf2',
  inputBg: '#ffffff',
  inputBorder: '#cbd5e1',
  success: '#d4edda',
  successText: '#155724',
  error: '#ffebee',
  errorText: '#c62828',
  advice: '#e8f5ef',
  adviceBorder: '#1D9E75',
  navBg: '#ffffff',
  navBorder: '#e8edf2',
  progressBg: '#e8edf2',
  deleteBtn: '#f8f9fa',
  deleteBtnBorder: '#e8edf2'
};

const darkColors = {
  page: '#121212',
  header: '#0a0a0a',
  card: '#1e1e1e',
  text: '#ffffff',
  textSecondary: '#cccccc',
  textLight: '#aaaaaa',
  textMuted: '#888888',
  border: '#333333',
  inputBg: '#2a2a2a',
  inputBorder: '#444444',
  success: '#1b3a2a',
  successText: '#7ddf9c',
  error: '#3a1b1b',
  errorText: '#ef9a9a',
  advice: '#1a2a22',
  adviceBorder: '#1D9E75',
  navBg: '#1e1e1e',
  navBorder: '#333333',
  progressBg: '#333333',
  deleteBtn: '#2a2a2a',
  deleteBtnBorder: '#444444'
};